export default "__VITE_ASSET__9a2dd661__"